<template>
	<div class="field">
		<div class="control has-icons-left">
			<input class="input" type="search" placeholder="Filter" :bind="$attrs" />
			<span class="icon is-left">
				<i class="fas fa-search"></i>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: "FieldText",
	inheritAttrs: false
};
</script>
